import Constants from '../model/AppConfiguration';
import moment from 'moment';

export default {
  allFlightsWireToInt: allFlightsWireToInt,
  // allFlightsIntToWire: allFlightsIntToWire,
};

function allFlightsWireToInt (wireFlights) {
  if (!wireFlights || !wireFlights.flights || !wireFlights.flights.flight) return [];
  wireFlights = wireFlights.flights.flight;
  let intFlights = [];

  for (let i = 0; i < wireFlights.length; i++) {
    let wireFlight = wireFlights[ i ];
    intFlights.push(wireFlightToInt(wireFlight));
  }

  return intFlights;
}

function wireFlightToInt (wireFlight) {
  const { flightid, total_seats, av_seats, is_selectable, date, type } = wireFlight._attributes;

  return {
    id: flightid,
    type: type ? type.toUpperCase() : '',
    date: date ? moment(date, Constants.SERVER_DATE_FORMAT).format(Constants.DATE_FORMAT) : '',
    totalSeats: total_seats ? parseInt(total_seats, 10) : 0,
    averageSeats: av_seats ? parseInt(av_seats, 10) : 0,
    text: `${av_seats}/${total_seats}`,
    enabled: is_selectable,
  };
}

// function allFlightsIntToWire (intFlights) {
// }



// WEBPACK FOOTER //
// ./src/converter/AllFlightsConverter.js